import { Component, OnInit, ViewChild } from '@angular/core';
import { Prestadores } from './prestadores.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-prestadores',
  templateUrl: './prestadores.component.html',
  styleUrls: ['./prestadores.component.scss']
})
export class PrestadoresComponent implements OnInit {

  @ViewChild('formident',{static: true})formident: NgForm;

  prestadores: any;
  

  //cambio a checkbox
  nombre: any;
  especialidad: any;
  sede: any;

  public opcionesSeleccionadas: any;
  constructor( private servicePrestadores: Prestadores) {
   
    //-------------------------- carga vacio en el constructor
    this.nombre = {};
    this.especialidad  ={};
    this.sede = {};   
    //--------------------------
   }

   getPrestadores(){
    return this.opcionesSeleccionadas;
    //return this.carreras;
  }

  ngOnInit(){
    this.prestadores = this.servicePrestadores.getPrestadores( );  
  }

  onSubmit(){      
    //ocultar o visibilizar la tabla de respuesta  
    document.getElementById('tablaCarreraNull').style.display = 'none';
    document.getElementById('tablaCarrera').style.display = 'none';
    this.opcionesSeleccionadas = [Array];
    let i = 0;
    let prestadores = this.prestadores;
    let nombre = this.formident.value.nombre.toUpperCase();
    let especialidad = this.formident.value.especialidad;
    let sede = this.formident.value.sede;         
    //nombre
    i=0;    
    if(nombre != '' && especialidad == '' && sede == ''){              
      for (let index = 0; index < prestadores.length; index++) {          
        if((prestadores[index].nombre).includes(nombre)){
          this.opcionesSeleccionadas[i] = prestadores[index];
          i++;            
        }
      }       
    }
    //especialidad
    if(especialidad != '' && sede == '' && nombre == ''){
      i=0;      
      for (let index = 0; index < prestadores.length; index++) {          
        if((prestadores[index].especialidad)==(especialidad)){
          this.opcionesSeleccionadas[i] = prestadores[index];
          i++; 
          }
        }
      } 
    
    //sede
    if(sede != '' && nombre == '' && especialidad == ''){
      i=0;      
      for (let index = 0; index < prestadores.length; index++) {          
        if((prestadores[index].locacion) == (sede)){
          this.opcionesSeleccionadas[i] = prestadores[index];
          i++; 
          }
        }
      } 
    /*
    //sedexduracion
    if(listasede.length != 0 && listaduracion.length != 0 && listaTipo.length == 0){
      i=0;      
      for (let indice = 0; indice < listasede.length; indice++){
        for (let indicador = 0; indicador < listaduracion.length; indicador++) {          
          for (let index = 0; index < carreras.length; index++) {          
            if(listasede[indice] == carreras[index].sede && listaduracion[indicador] == carreras[index].duracion){              
              this.carrerasSeleccionadas[i] = carreras[index];
              i++;              
            }
          }
        }
      } 
    }
    //sedextipo
    if(listasede.length != 0 && listaduracion.length == 0 && listaTipo.length != 0){
      i=0;      
      for (let indice = 0; indice < listaTipo.length; indice++){
        for (let indicador = 0; indicador < listasede.length; indicador++) {          
          for (let index = 0; index < carreras.length; index++) {          
            if(listaTipo[indice] == carreras[index].tipo && listasede[indicador] == carreras[index].sede){              
              this.carrerasSeleccionadas[i] = carreras[index];
              i++;              
            }
          }
        }
      } 
    }
    //tipoxduracion
    if(listasede.length == 0 && listaduracion.length != 0 && listaTipo.length != 0){
      i=0;      
      for (let indice = 0; indice < listaTipo.length; indice++){
        for (let indicador = 0; indicador < listaduracion.length; indicador++) {          
          for (let index = 0; index < carreras.length; index++) {          
            if(listaTipo[indice] == carreras[index].tipo && listaduracion[indicador] == carreras[index].duracion){              
              this.carrerasSeleccionadas[i] = carreras[index];
              i++;              
            }
          }
        }
      } 
    }
    //sedexduracionxtipo
    if(listasede.length != 0 && listaduracion.length != 0 && listaTipo.length != 0){
      i=0;      
      for (let indice = 0; indice < listaTipo.length; indice++){
        for (let indicador = 0; indicador < listasede.length; indicador++) {          
          for (let indice2 = 0; indice2 < listaduracion.length; indice2++){          
            for (let index = 0; index < carreras.length; index++) {          
              if(listaTipo[indice] == carreras[index].tipo && listasede[indicador] == carreras[index].sede && listaduracion[indice2] == carreras[index].duracion){              
                this.carrerasSeleccionadas[i] = carreras[index];
                i++;              
              }
            }
          }
        }
      } 
    }
    function getCheckedCheckboxesFor(checkboxName) {
      var checkboxes = document.querySelectorAll('input[name="' + checkboxName + '"]:checked'), values = [];
      Array.prototype.forEach.call(checkboxes, function(el) {
          values.push(el.value);
      });
      return values;
  }
   */

    if (this.opcionesSeleccionadas[0] == "function Array() { [native code] }") {
      document.getElementById('tablaCarreraNull').style.display = 'table';
    }else{
      document.getElementById('tablaCarrera').style.display = 'table';      
    }
  }

}
